import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Promise from 'bluebird';
import GiftSection from './GiftSection';
import UserAddresses from 'components/userAddresses';
import UserAddressForm from 'components/userAddresses/form';
import { setAddress } from 'shared/components/address/actions';
import { toggleGift } from 'components/checkoutPage/actions';
import { validEmail } from 'shared/models/user';
import GiftIcon from 'images/icons/cheers-glasses.svg?react-svg';
import { Checkbox } from 'scy/Input';
import Icon from './Icon';
import Title from './Title';
import { SecondarySmallAlt } from 'scy/text';
import { checkbox } from '../styles.mod.scss';
import { expandedCheckboxLabel } from './styles.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';

class Expanded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {}
    };
  }

  validateRecipient(name) {
    if (_.isEmpty(name)) return "Recipient Name can't be blank";
  }

  validateEmail(email) {
    if (email && !validEmail(email)) return 'Enter a valid email address';
  }

  validateGiftFields() {
    const { isGift, giftRecipient, giftMobile } = this.props;

    let errors = {};
    errors.giftRecipient = isGift
      ? this.validateRecipient(giftRecipient)
      : null;
    errors.giftMobile =
      isGift && this.validateMobile ? this.validateMobile(giftMobile) : null;

    this.setState({ errors });
    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  selectUserAddress(address) {
    const trackingParams = { page: 'Checkout', source: 'Saved Addresses' };
    return this.props.setAddress(address, {
      ...trackingParams,
      checkout: true
    });
  }

  setNewAddress(address) {
    const trackingParams = { page: 'Checkout', source: 'Checkout Form' };
    return this.props.setAddress(address, {
      ...trackingParams,
      checkout: true
    });
  }

  render() {
    return (
      <>
        <div className={`${flex} ${centerItems} ${margin.bottom_sm}`}>
          <Icon />
          <Title />

          <SecondarySmallAlt
            tag="label"
            htmlFor="isGift"
            className={expandedCheckboxLabel}
          >
            <GiftIcon />
            <span
              className={`${textCenter} ${margin.left_xs} ${margin.right_xs}`}
            >
              Send as a gift?
            </span>
            <Checkbox
              id="isGift"
              name="isGift"
              className={checkbox}
              checked={this.props.isGift}
              onChange={() => this.props.toggleGift()}
            />
          </SecondarySmallAlt>
        </div>

        <>
          {this.props.isGift && (
            <GiftSection
              validateRecipient={name => this.validateRecipient(name)}
              validateEmail={email => this.validateEmail(email)}
              forwardMobileValidator={validate =>
                (this.validateMobile = validate)
              }
              giftRecipientError={this.state.errors.giftRecipient}
              giftMobileError={this.state.errors.giftMobile}
            />
          )}

          {!this.props.userAddresses.length ? (
            <UserAddressForm
              address={this.props.address}
              onBeforeSubmit={() => this.validateGiftFields()}
              onSubmit={address => this.setNewAddress(address)}
              onSuccess={() => this.props.collapse()}
              autoFocus={!this.props.isGift}
            />
          ) : (
            <UserAddresses
              selectedAddress={this.props.address}
              onBeforeSubmit={() => this.validateGiftFields()}
              onSelectionChange={address => this.selectUserAddress(address)}
              onSelectionSubmit={() => this.props.collapse()}
              onNewAddressSubmit={address => this.setNewAddress(address)}
              onNewAddressSuccess={() => this.props.collapse()}
              onUpdateAddressSuccess={address =>
                this.selectUserAddress(address)
              }
              autoFocus={!this.props.isGift}
              autoScroll={!this.props.isGift}
            />
          )}
        </>
      </>
    );
  }
}

const ConnectedExpanded = connect(
  state => ({
    isGift: state.checkout.isGift,
    giftRecipient: state.checkout.giftRecipient,
    giftMobile: state.checkout.giftMobile,
    address: state.address,
    userAddresses: state.userAddresses.addresses
  }),
  { toggleGift, setAddress }
)(Expanded);

export default ConnectedExpanded;
